<template>
  <!-- <div v-if="Object.keys(this.tableData).length > 0"> -->
  <div v-if="this.mdetailShow">
    <div>
      <div class="inner product_info_content pb-0 pr-0 pl-0">
        <v-tabs style="max-width: fit-content">
          <v-tab @change="filterDomainSellers">
            <span>All</span>
          </v-tab>
          <v-tab
            v-for="client in product['product_clients']"
            :key="`${client.client_id}_${client['client_name']}`"
            @change="changeFilterClient(client.client_id)"
          >
            <label class="i-v-radio client">
              <span>{{ client["client_name"] || "_" }}</span>
            </label>
          </v-tab>
        </v-tabs>
        <div class="product_date_info product_date">
          <span class="date">{{
            product["product_info"]["created_at"].date
          }}</span>
          <span class="time">{{
            product["product_info"]["created_at"].time
          }}</span>
          <v-btn
            text
            color="primary"
            class="m-w delete_row"
            @click="
              $emit(
                'removeProductFromSelected',
                product['product_info'].product_id
              )
            "
          >
            <v-icon>close</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="inner product_info_content">
        <template>
          <div class="product_info ml-5">
            <p>{{ product["product_info"]["product_brand"].name || "_" }}</p>
          </div>
          <div class="product_info product_info_name">
            <p>{{ product["product_info"].product_name || "_" }}</p>
          </div>
          <div class="product_info">
            <p>Sku 1</p>
          </div>
          <div class="product_info">
            <p>Sku 2</p>
          </div>
          <div class="product_info">
            <p>Ean</p>
          </div>
        </template>
        <div class="product_info">
          <label class="i-checkbox">
            <input
              type="checkbox"
              class="ma-0 custom-checkbox product_checkbox"
              ref="childCheckboxSeller"
              @change="
                selectAllChechboxes($event.target.checked);
              "
            />
            <span class="checkmark" ></span>
          </label>
        </div>
      </div>
      <div class="inner pb-3">
        <v-btn
          text
          :ripple="false"
          class="ex-btn ex-primary-btn"
          @click="$emit('addUrlToProduct')"
        >
          <v-icon>add</v-icon>
          Add Urls
        </v-btn>
        <span
          id="element1"
          ref="name_brand"
          v-if="!product.product_info.product_id"
        >
          <!--  v-if="product['product_info'].product_name == '' || product['product_info'].product_name == null" -->
          <!--dini onoma eteria-->
          <input type="text" placeholder="Name" v-model="Pname" class="white" />
          <input
            type="text"
            placeholder="Manufacturer"
            v-model="Pbrand"
            class="white"
          />
          <v-btn @click="addName()">Add name & Brand</v-btn>
        </span>

        <span class="extract-product" v-if="!product.product_info.product_id">
          <v-select
            id="clients"
            v-model="domainForExtract"
            :items="domainsForExtractList"
            :hide-details="true"
            no-data-text="No Domains"
            label="Select the domain"
            class="ex-secondary-dropdown"
            item-text="domain_name"
            item-value="domain_id"
            solo
            @change="changeExtractDomain"
          >
          </v-select>
          <v-btn
            text
            :ripple="false"
            class="ex-btn ml-1 custom_button ex-primary-btn"
            elevation="2"
            @click="extractProduct"
          >
            Extract Product
          </v-btn>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { productDetailsBus } from "@/helpers/buses.js";

export default {
  name: "ProductDetailsInfo",
  props: {
    product: {
      type: [Object, Array],
      default: null,
    },
    index: Number,
  },
  data: () => ({
    Myshow: true,
    Pname: "",
    Pbrand: "",
    clientFilterChecked: false,
    selectedClientId: null,
    domainForExtract: null,
  }),
  methods: {
    returnProductId() {
      if (product["product_info"].product_id > 0)
        return product["product_info"].product_id;
      else return 0;
    },

    addName() {
      if (this.Pname == "" || this.Pbrand == "") {
        alert("Name and Brand must not be blank");
        return;
      }
      this.$store.commit("productModule/ADD_NAME", this.Pname);
      this.$store.commit("productModule/ADD_BRAND", this.Pbrand);
      this.Pname = "";
      this.Pbrand = "";
    },
    selectedClientSellers() {
      const productClient = this.product["product_clients"].find(
        (client) => client.client_id === this.selectedClientId
      );
      if (productClient) {
        return productClient["client_sellers"];
      }
    },
    filterDomainSellers() {
      this.selectedClientId = null;
      this.$emit("filterDomainSellers");
    },
    changeFilterClient(clientId) {
      this.selectedClientId = clientId;
      this.$emit(
        "filterDomainSellers",
        this.selectedClientSellers(),
        this.index
      );
    },
    changeExtractDomain(e) {
      console.log(e);
    },
    extractProduct() {
      // eslint-disable-next-line eqeqeq
      const payload = {
        product_domain: this.product.product_domains.find(
          (domain) => domain.domain_id == this.domainForExtract
        ),
      };
      console.log("STEP 1");
      this.$emit("extractProduct", payload);
    },
    selectAllChechboxes(isChecked) {
      // console.log('selectAll','Info')
      // console.log('e',isChecked);
      // emit by bus ProductTable and ProductDetailsTable that all must be checked
      productDetailsBus.$emit('selectAll', isChecked);
      this.$emit(
                  'chooseProduct',
                  isChecked,
                  this.product['product_info'].product_id
                );
    }
  },
  computed: {
    tableData() {
      return this.$store.state.productModule.urlsContainer;
    },
    mdetailShow() {
      return this.$store.state.productModule.DetailsShow;
    },
    domainsForExtractList() {
      return this.product.product_domains.filter(
        (domain) => domain.product_extract
      );
    },
  },
};
</script>

<style scoped>
.white {
  max-width: 700px;
  margin: auto;
  color: black;
}
.clients_content {
  display: flex;
  align-items: center;
}

.clients_content > .client {
  margin: 0 12px;
  padding: 0 8px;
  min-width: 80px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: 2px solid rgba(255, 255, 255, 0.05);
}

.clients_content > .client > .client_checkbox {
  width: 22px;
}

.product_date {
  border: 4px solid #121212;
  display: flex;
  align-items: center;
}

.date {
  border-right: 2px solid #121212;
}

.time,
.date {
  padding: 0 12px;
}

.delete_row {
  height: 0;
  min-width: 0;
  padding: 18px 16px;
  border-left: 2px solid black;
}

.product_info_name {
  max-width: 200px;
}

.custom_button {
  height: 48px !important;
}

.extract-product {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/product/ProductDetailsInfo.vue